import { useState } from 'react'
import { useContext, useContextSelector } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { saveSection } from 'states/PromoPageState/reducer'
import { SectionState } from 'states/PromoPageState/state'
import { eLockInfo, Links } from 'sections/PromoSection/modules/ELockModule/components/Description/types'
import { AdminAddElemButton } from 'components/AdminV2/UI/AddElemButton/AdminAddElemButton'
import { AdminElemVisibilityToggle } from 'components/AdminV2/UI/ElemVisibilityToggle/AdminElemVisibilityToggle'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminSaveButton } from 'components/AdminV2/UI/SaveButton/AdminSaveButton'
import { ElockData, ElockHowToInstallData } from 'types/types'

import { ElockBlockItem } from './ElockBlockItem/ElockBlockItem'

import s from './ElockBlock.module.scss'

export const ElockBlock = () => {
  const state = useContextSelector(PromoPageStateContext, (context) =>
    context.state.sections.find((section) => section.type === 'ELock'),
  ) as SectionState

  const ctx = useContext(PromoPageStateContext)

  const [localPromoState, setLocalPromoState] = useState<SectionState>(state)
  const [isVisible, setVisible] = useState(false)
  const [isInstallDataVisible, setInstallDataVisible] = useState(false)

  const data = (state.content as ElockData) || { elockTableData: {}, elockHowToInstallData: [] }

  const handleSave = () => {
    const stateCopy = { ...localPromoState }
    stateCopy.content = {
      ...stateCopy.content,
      elockTableData: Object.values((stateCopy.content as ElockData).elockTableData),
    }
    ctx.dispatch(saveSection(stateCopy))
  }

  const addLockModelHandler = () => {
    const stateCopy = { ...localPromoState }
    const lockData = (stateCopy.content as ElockData).elockTableData
    const newIndex = lockData.length

    lockData.push({
      index: newIndex,
      model: '',
      type: '',
      lockType: '',
      forDoors: '',
      voltage: '',
      current: '',
      keyOpen: '',
      alwaysOpen: '',
      links: {},
      details: '',
    })
    setLocalPromoState(stateCopy)
  }

  const handleChange = (index: number, key: Exclude<keyof eLockInfo, 'links'>, value: string) => {
    const stateCopy = { ...localPromoState }
    const lock = (stateCopy.content as ElockData).elockTableData.find((item) => item.index === index)

    if (lock) {
      ;(lock[key] as string) = value
    }

    setLocalPromoState(stateCopy)
  }

  const handleInstallDataChange = (index: number, key: keyof ElockHowToInstallData, value: string) => {
    const stateCopy = { ...localPromoState }
    const installData = (stateCopy.content as ElockData).elockHowToInstallData[index]

    if (installData) {
      ;(installData[key] as string) = value
    }

    setLocalPromoState(stateCopy)
  }

  const handleLinksChange = (index: number, linkKey: keyof Links, value: string) => {
    const stateCopy = { ...localPromoState }
    const lock = (stateCopy.content as ElockData).elockTableData.find((item) => item.index === index)

    if (lock) {
      ;(lock.links as Links)[linkKey] = value
    }

    setLocalPromoState(stateCopy)
  }

  const deleteLockModelHandler = (index: number) => {
    setLocalPromoState((prevState) => {
      const stateCopy = { ...prevState }
      const updatedLocks = [...(stateCopy.content as ElockData).elockTableData].filter((lock) => lock.index !== index)

      updatedLocks.forEach((lock, i) => (lock.index = i))

      return {
        ...stateCopy,
        content: {
          ...stateCopy.content,
          elockTableData: updatedLocks,
        },
      }
    })
  }

  return (
    <div className={s.elock}>
      <AdminElemVisibilityToggle text="Популярные модели замков:" isVisible={isVisible} setVisible={setVisible} />

      {isVisible && (
        <div>
          {(localPromoState.content as ElockData).elockTableData.map((lock) => (
            <ElockBlockItem
              key={lock.index}
              lock={lock}
              onChange={handleChange as (index: number, key: Exclude<keyof eLockInfo, 'links'>, value: string) => void}
              onLinkChange={handleLinksChange}
              onDelete={deleteLockModelHandler}
            />
          ))}
          <AdminAddElemButton text="Добавить модель замка" onClick={addLockModelHandler} />
        </div>
      )}

      <AdminElemVisibilityToggle
        text="Инструкции по установке:"
        isVisible={isInstallDataVisible}
        setVisible={setInstallDataVisible}
      />

      {isInstallDataVisible && (
        <>
          {(data.elockHowToInstallData || []).map((item, index) => (
            <>
              <AdminInput
                label="Инструкция по установке контроллера"
                value={item.installationInstructions}
                onChange={(value) => handleInstallDataChange(index, 'installationInstructions', value)}
              />
              <AdminInput
                label="Описание контроллера"
                value={item.controllerDescription}
                onChange={(value) => handleInstallDataChange(index, 'controllerDescription', value)}
              />
            </>
          ))}
        </>
      )}

      <AdminSaveButton onClick={handleSave} />
    </div>
  )
}
